import React  from 'react';
import PropTypes from 'prop-types';

import styles from './sidebarHeader/sidebarHeader.module.scss';

export const SidebarHeader = ({ title, onCloseClick = () => {} }) => (
  <header className={styles.header}>
    <h4 className={styles.title}>
      {title}
    </h4>
    <button
      className={`btn-cross ${styles.close}`}
      onClick={onCloseClick}
    />
  </header>
);

SidebarHeader.propTypes = {
  className: PropTypes.string,
  onCloseClick: PropTypes.func,
}
